<template>
  <v-dialog
      v-model="isOpen"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('serviceSettings.customService.colorLabel') }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>

            <div class="ColorPicker-colorContainer">
              <div v-for="(palette, index) in colors" :key="index">
                <div
                  class="ColorPicker-color"
                  v-for="(color, index) in palette"
                  :key="index"
                  :style="`background: ${color};`"
                  :class="{ 'ColorPicker-color--selected': selectedColor === color }"
                  @click="selectedColor = color"
                />
              </div>
            </div>
            
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="cancelColor"
          >
            {{ $t('serviceSettings.customService.dialogClose') }}
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="validColor"
          >
            {{ $t('serviceSettings.customService.dialogConfirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  name: 'ColorPicker',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selectedColor: '',
      colors: [
        [
          "#195ba5",
          "#497db8",
          "#7aa0cb",
          "#aac3de"
        ],
        [
          "#6d60c7",
          "#8b82d3",
          "#aaa3df",
          "#c9c5ea"
        ],
        [
          "#ff6472",
          "#ff8590",
          "#ffa5ae",
          "#ffc6cb"
        ],
        [
          "#f59b5d",
          "#f7b07f",
          "#f9c5a1",
          "#fbdac3"
        ],
        [
          "#ffd823",
          "#ffe052",
          "#ffe980",
          "#fff1ae"
        ],
        [
          "#66c1b7",
          "#86cec6",
          "#a7dbd5",
          "#c7e8e4"
        ]
      ]
    }
  },
  methods: {
    cancelColor() {
      this.selectedColor = ''
      this.$emit('close')
    },
    validColor() {
      this.$emit('input', this.selectedColor)
      this.selectedColor = ''
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.ColorPicker-colorContainer {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
}

.ColorPicker-color {
  height: 30px;
  width: 30px;
  border-radius: 50%;
  margin: 30px auto;
  cursor: pointer;
  border: 4px solid transparent;
  transition: .3s;

  &:hover {
    border: 4px solid #c2c2c2;
    transform: scale(1.25);
  }

  &--selected {
    border: 4px solid #444;
    transform: scale(1.25);

    &:hover {
      border: 4px solid #444;
    }
  }

  &--noHover {
    height: 20px;
    width: 20px;
    &:hover {
      border: 4px solid transparent;
      transform: scale(1);
    }
  }
}
</style>